const initialisePracticeBlocks = () => {
	document.querySelectorAll('[data-illustrate-practice]').forEach((block) => {
		block.dataset.illustratePracticeReady = 'true';
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initialisePracticeBlocks);
} else {
	initialisePracticeBlocks();
}
